<template>
<div class="wrpa">
    <div class="search_box flex_box">
        <div>
            <el-date-picker
                v-model="searchParams.times"
                type="daterange"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="活动开始日期"
                end-placeholder="活动结束日期">
            </el-date-picker>
        </div>
        <div style="width: 108px;">
            <el-select v-model="searchParams.orderStatus" placeholder="订单状态">
                <el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 108px;">
            <el-select v-model="searchParams.ordertType" placeholder="订单类型">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 140px;">
            <el-input v-model="searchParams.username" placeholder="请输入用户昵称"></el-input>
        </div>
        <div style="width: 220px;">
            <el-input v-model="searchParams.activityname" placeholder="请输入活动名称"></el-input>
        </div>
        <div>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            <el-button @click="exportBtn">导出</el-button>
        </div>
    </div>
    <div class="table_box">
        <el-table :data="orderListData" style="width: 100%">
            <el-table-column prop="orderno" label="订单号" width="160"></el-table-column>
            <el-table-column label="用户名称" width="180">
                <template slot-scope="scope">
                    <div class="user_info_box flex_box">
                        <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="活动名称" width="300" align='center'>
                <template slot-scope="scope">
                    <p class="activity_name_text">{{scope.row.eventname}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="mkordertype" label="订单类型" align='center'></el-table-column>
            <el-table-column prop="ordermoney" label="订单金额" align='center'></el-table-column>
            <el-table-column prop="ordertime" label="订单时间" align='center' width="160"></el-table-column>
            <el-table-column label="订单状态" align='center'>
                <template slot-scope="scope">
                    <p :class="orderStatusClass(scope.row.statusname)">{{scope.row.statusname}}</p>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='right' width="150">
                <template slot-scope="scope">
                    <div class="handle_box flex_box">
                        <span @click="findOrderDetail(scope.row)">订单详情</span>
                        <span v-if="scope.row.mkordertypevalue === 2">&nbsp;|&nbsp;</span>
                        <span v-if="scope.row.mkordertypevalue === 2" @click="findHelpDetail(scope.row)">助力详情</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="order_detail_pop_box">
        <!-- 订单详情弹窗 -->
        <OrderDetailPop :orderDetailsInfo="orderDetailsInfo" ref="orderDetails"></OrderDetailPop>
    </div>
    <div class="help_detail_pop_box">
        <!-- 助力详情弹窗 -->
        <HelpDetailPop :assDetailsInfo="assDetailsInfo" ref="helpDetails"></HelpDetailPop>
    </div>
</div>
</template>

<script>
import OrderDetailPop from 'views/taskTools/helpManagement/components/OrderDetailPop'
import HelpDetailPop from 'views/taskTools/helpManagement/components/HelpDetailPop'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getAssOrderList, getEventOrderInfo, getAssOrderInfo, getEventOrderExportInfo} from 'api/taskToolsApi2'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'OrderAdmin',
    data() {
        return {
            activeName: 'first',
            total: 0,
            searchParams: {
                username: '',
                activityname: '',
                orderStatus: '',
                ordertType: '',
                times: ''
            },
            orderStatusOptions: [
                {
                    value: '0',
                    label: '全部状态'
                },
                {
                    value: '9',
                    label: '待支付'
                },
                {
                    value: '1',
                    label: '待核销'
                },
                {
                    value: '30',
                    label: '已完成'
                },
                {
                    value: '100',
                    label: '已取消'
                }
            ],
            typeOptions: [
                {
                    value: '0',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '直接购买'
                },
                {
                    value: '2',
                    label: '助力订单'
                }
            ],
            orderListData: [],
            orderDetailsInfo: {},
            assDetailsInfo: {}
        }
    },
    mounted() {
        this.getOrderList()
    },
    methods: {
        // 订单管理列表导出
        exportBtn() {
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            this.setLoading(true)
            var params = {
                begintime: this.searchParams.times[0],
                endtime: this.searchParams.times[1],
                status: this.searchParams.orderStatus === '0' ? '' : this.searchParams.orderStatus,
                mkordertype: this.searchParams.ordertType === '0' ? '' : this.searchParams.ordertType,
                customername: this.searchParams.username,
                eventname: this.searchParams.activityname
            }
            getEventOrderExportInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '订单管理' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    // this.$message.success('导出成功')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 订单列表
        getOrderList() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getAssOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 订单详情（弹窗）
        findOrderDetail(val) {
            // this.setLoading(true)
            var params = {
                orderno: val.orderno
            }
            getEventOrderInfo({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    this.orderDetailsInfo = data.data
                    this.$refs.orderDetails.openDialog()
                },
                error: data => {
                    console.log('error：', data)
                    // this.setLoading(false)
                }
            })
        },
        // 助力详情（弹窗）
        findHelpDetail(val) {
            // this.setLoading(true)
            // console.log(val)
            var params = {
                orderno: val.assorderno
            }
            getAssOrderInfo({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    this.assDetailsInfo = data.data
                    this.$refs.helpDetails.openDialog()
                },
                error: data => {
                    console.log('error：', data)
                    // this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            // console.log(this.searchParams)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                begintime: this.searchParams.times[0],
                endtime: this.searchParams.times[1],
                status: this.searchParams.orderStatus === '0' ? '' : this.searchParams.orderStatus,
                mkordertype: this.searchParams.ordertType === '0' ? '' : this.searchParams.ordertType,
                customername: this.searchParams.username,
                eventname: this.searchParams.activityname
            }
            // console.log(params)
            getAssOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        orderStatusClass(val) {
            if (val === '已取消') {
                return 'gray_text'
            } else if (val === '已完成' || val === '已核销') {
                return 'green_text'
            } else if (val === '待核销' || val === '待支付') {
                return 'yellow_text'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page,
        OrderDetailPop,
        HelpDetailPop
    }
}
</script>

<style lang="scss" type="text/scss"></style>